export default "__VITE_ASSET__D0ERnw88__"